import { render } from "./dependents-incorporation-form-error.vue?vue&type=template&id=8ef26aec"
const script = {}

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__